import { render, staticRenderFns } from "./uploadSixImage.vue?vue&type=template&id=06511b94&scoped=true&"
import script from "./uploadSixImage.vue?vue&type=script&lang=js&"
export * from "./uploadSixImage.vue?vue&type=script&lang=js&"
import style0 from "./uploadSixImage.vue?vue&type=style&index=0&id=06511b94&scoped=true&lang=less&"
import style1 from "./uploadSixImage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06511b94",
  null
  
)

export default component.exports